(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wallford-product-ar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wallford-product-ar')) {
    customElements.define('wallford-product-ar', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('product-info');
        this.action = this.querySelector('.wf-product-ar__action');
        if (!this.root || !this.action) return;
        this.observer = new MutationObserver(() => this.placeViewer());
        this.observer.observe(this.root, { childList: true, subtree: true });
        this.placeViewer();
      }
      placeViewer() {
        const wrapper = this.root.querySelector('.swiftxr-embed-wrapper');
        if (wrapper && !this.action.contains(wrapper)) this.action.append(wrapper);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
